import { CSS } from "../../../styles"

export const root = (): CSS => ({
  margin: `0 auto`,
})
